<div class="px-3 pt-3">
  <app-filter-card (onApply)="filterCardData$.next($event)"></app-filter-card>
  <mat-card appearance="outlined">
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="store.data$()"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        [customColumnDef]="[
          { name: 'name', template: isNameCell, isSortable: true },
          { name: 'isActive', template: isActiveCell, isSortable: true },
        ]"
        (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
        (editClick)="initializeEdit()"
        (addClick)="initializeAdd()"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
      />
    </mat-card-content>
  </mat-card>
</div>
<ng-template #isNameCell let-row="row">
  <div class="link" (click)="openFormEditor(row)">
    {{ row.isDefault ? ('system.label.' + row.name | translate) : row.name }}
    <mat-chip *ngIf="row.isDefault"> {{ 'system.label.default' | translate | uppercase }}</mat-chip>
  </div>
</ng-template>

<ng-template #isActiveCell let-row="row">
  <mat-pill
    [class]="row.isActive ? 'green' : 'red'"
    [text]="(row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase"
  >
  </mat-pill>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput formControlName="name" />
        <mat-error [control]="addEditForm.get('name')"></mat-error>
      </mat-form-field>
      <div class="bulk-dialog-field">
        <mat-checkbox
          *ngIf="isBulkEdit()"
          (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isActive'))"
        >
        </mat-checkbox>
        <mat-checkbox formControlName="isActive">
          {{ 'field.active' | translate }}
        </mat-checkbox>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #formEditorDialog>
  <h1 mat-dialog-title *ngIf="selectedFormSetting">
    {{ selectedFormSetting.name }}
  </h1>
  <app-form-editor (editedFormChanged)="getEditedForm($event)"></app-form-editor>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit" (click)="onSubmit()">{{ 'button.saveChanges' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
